export type FormsStartAutocompleteFunctionType = () => void;

export interface FormsStartAutocompleteActionType {
  type: '@forms/START_AUTOCOMPLETE';
}

export const startAutocomplete = (): FormsStartAutocompleteActionType => ({
  type: '@forms/START_AUTOCOMPLETE',
});
